module.exports = __webpack_public_path__ + "img/PetPlayPalsLogo.0d1c2267.png";